import Work from "./experience/Work";

const Experience = () => {
  return (
    <>
      <h2>Work experience</h2>

      <Work />
    </>
  );
};

export default Experience;
